module.exports = __webpack_public_path__ + "static/media/nidalee-lose.571a7534.png";